
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.7.1
 * Query Engine version: 272861e07ab64f234d3ffc4094e32bd61775599c
 */
Prisma.prismaVersion = {
  client: "4.7.1",
  engine: "272861e07ab64f234d3ffc4094e32bd61775599c"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val


/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.AuctionScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  listingId: 'listingId',
  startTime: 'startTime',
  endTime: 'endTime',
  durationMs: 'durationMs',
  minimumAmountCents: 'minimumAmountCents',
  athevaFeeCents: 'athevaFeeCents',
  saleFormat: 'saleFormat',
  buyNowPriceCents: 'buyNowPriceCents',
  settledAt: 'settledAt',
  winningBidId: 'winningBidId',
  secondPriceCents: 'secondPriceCents',
  paymentInitiated: 'paymentInitiated',
  paymentSucceeded: 'paymentSucceeded',
  stripePaymentId: 'stripePaymentId',
  combinedCsaEnvelopeId: 'combinedCsaEnvelopeId'
});

exports.Prisma.BidScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  buyerId: 'buyerId',
  auctionId: 'auctionId',
  amountCents: 'amountCents',
  contractAgentType: 'contractAgentType',
  contractAgentUserId: 'contractAgentUserId',
  contractAgentFirstNotifiedAt: 'contractAgentFirstNotifiedAt',
  csaSignDate: 'csaSignDate',
  csaEnvelopeId: 'csaEnvelopeId'
});

exports.Prisma.BuyerScalarFieldEnum = makeEnum({
  id: 'id',
  stripeCustomerId: 'stripeCustomerId',
  stripeSetupIntentId: 'stripeSetupIntentId',
  stripeClientSecret: 'stripeClientSecret',
  stripeBuyerOnboarded: 'stripeBuyerOnboarded',
  stripeBuyerMandateSigRequired: 'stripeBuyerMandateSigRequired',
  stripeBuyerFixRequired: 'stripeBuyerFixRequired',
  userId: 'userId'
});

exports.Prisma.DocusignTokenScalarFieldEnum = makeEnum({
  accessToken: 'accessToken',
  expiresAt: 'expiresAt'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
});

exports.Prisma.ListingActionScalarFieldEnum = makeEnum({
  id: 'id',
  listingId: 'listingId',
  action: 'action',
  actorType: 'actorType',
  actorId: 'actorId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.ListingScalarFieldEnum = makeEnum({
  id: 'id',
  publicId: 'publicId',
  creditType: 'creditType',
  creditAmountCents: 'creditAmountCents',
  visibility: 'visibility',
  sellerVisibility: 'sellerVisibility',
  numProjects: 'numProjects',
  availability: 'availability',
  taxCreditSource: 'taxCreditSource',
  questionnaire: 'questionnaire',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  postedForInterestAt: 'postedForInterestAt',
  sellerId: 'sellerId',
  indemnification: 'indemnification',
  contractAgentType: 'contractAgentType',
  contractAgentUserId: 'contractAgentUserId',
  contractAgentFirstNotifiedAt: 'contractAgentFirstNotifiedAt',
  csaSignDate: 'csaSignDate',
  csaEnvelopeId: 'csaEnvelopeId'
});

exports.Prisma.NullableJsonNullValueInput = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.SellerScalarFieldEnum = makeEnum({
  id: 'id',
  stripeConnectToken: 'stripeConnectToken',
  stripeConnectOnboarded: 'stripeConnectOnboarded',
  stripeRequirementsCount: 'stripeRequirementsCount',
  userId: 'userId',
  isCustomListingNdaEnabled: 'isCustomListingNdaEnabled',
  listingNdaTemplateId: 'listingNdaTemplateId',
  isListingNdaSignable: 'isListingNdaSignable'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.SupportingDocScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  listingId: 'listingId',
  isConfidential: 'isConfidential',
  filename: 'filename',
  key: 'key',
  mimetype: 'mimetype',
  url: 'url',
  type: 'type'
});

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserAuctionViewScalarFieldEnum = makeEnum({
  lastViewedAt: 'lastViewedAt',
  auctionId: 'auctionId',
  userId: 'userId'
});

exports.Prisma.UserIdentifyingTokenScalarFieldEnum = makeEnum({
  tokenHash: 'tokenHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  purpose: 'purpose',
  expiresAt: 'expiresAt',
  usedAt: 'usedAt'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  company: 'company',
  title: 'title',
  marketplaceSide: 'marketplaceSide',
  source: 'source',
  additionalInfo: 'additionalInfo',
  passwordHash: 'passwordHash',
  emailVerified: 'emailVerified',
  referralCode: 'referralCode',
  referrerCode: 'referrerCode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  creditRating: 'creditRating'
});
exports.ListingVisibility = makeEnum({
  PUBLIC: 'PUBLIC',
  UNLISTED: 'UNLISTED'
});

exports.MarketplaceSide = makeEnum({
  BUY: 'BUY',
  SELL: 'SELL',
  UNKNOWN: 'UNKNOWN'
});

exports.SaleFormat = makeEnum({
  AUCTION: 'AUCTION',
  AUCTION_WITH_BUY_NOW: 'AUCTION_WITH_BUY_NOW'
});

exports.SellerVisibility = makeEnum({
  PUBLIC: 'PUBLIC',
  COMPANY: 'COMPANY',
  STATS_ONLY: 'STATS_ONLY',
  PRIVATE: 'PRIVATE'
});

exports.SignerType = makeEnum({
  SELF: 'SELF',
  OTHER: 'OTHER'
});

exports.Prisma.ModelName = makeEnum({
  User: 'User',
  Buyer: 'Buyer',
  Seller: 'Seller',
  Listing: 'Listing',
  Auction: 'Auction',
  Bid: 'Bid',
  SupportingDoc: 'SupportingDoc',
  DocusignToken: 'DocusignToken',
  UserIdentifyingToken: 'UserIdentifyingToken',
  UserAuctionView: 'UserAuctionView',
  ListingAction: 'ListingAction'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
